/**
 * Find the best-matching remark index for a removal query.
 * Uses case-insensitive substring containment; returns -1 if no match.
 */
export function findRemarkMatch(items: string[], query: string): number {
  const q = query.toLowerCase().trim();
  if (!q) return -1;
  // Exact match first
  const exact = items.findIndex((s) => s.toLowerCase().trim() === q);
  if (exact !== -1) return exact;
  // Query contained in item (item is more specific)
  const contained = items.findIndex((s) => s.toLowerCase().includes(q));
  if (contained !== -1) return contained;
  // Item contained in query (query is more specific)
  const reverse = items.findIndex((s) => q.includes(s.toLowerCase().trim()));
  if (reverse !== -1) return reverse;
  return -1;
}

/** Parse a remarks field value stored as a JSON string array. */
export function parseRemarksList(raw: string): string[] {
  if (!raw || !raw.trim()) return [];
  const parsed: unknown = JSON.parse(raw);
  if (!Array.isArray(parsed) || parsed.some((value) => typeof value !== "string")) {
    throw new Error("Section remarks must be a JSON string array");
  }
  return parsed.filter((value): value is string => typeof value === "string" && value.trim() !== "");
}

export function serializeRemarksList(items: string[]): string {
  const clean = items.map((s) => s.trim()).filter(Boolean);
  return clean.length === 0 ? "" : JSON.stringify(clean);
}
